import { render } from "./InfoboardDescription.vue?vue&type=template&id=24dc0d8a&ts=true"
import script from "./InfoboardDescription.vue?vue&type=script&lang=ts"
export * from "./InfoboardDescription.vue?vue&type=script&lang=ts"

import "./InfoboardDescription.vue?vue&type=style&index=0&id=24dc0d8a&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.39_vue@3.5.39_typescript@6.0.3__webpack@5.108.0_esbuild@0.28.0_postcss@8.5.25_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__